import { Curriculum } from "../../../../api/types";
import React from "react";
import { Text, View } from "@react-pdf/renderer";
import { asgmtDetailsStyle } from "./AssignmentResultsContent";

interface AssignmentCurrDisplayProps {
	currList: Curriculum[];
}

// display list of <CurriculumName, AggregatedCurriculumCodes> for each assignment
export const AssignmentCurriculumDisplay: React.FC<
	AssignmentCurrDisplayProps
> = ({ currList }): JSX.Element => {
	let assignmentNameCurrMap: Map<string, string> = new Map();
	if (currList) {
		assignmentNameCurrMap = aggregateCurriculum(currList);
	}
	return (
		<View style={asgmtDetailsStyle.assignmentCurriculumContainer}>
			{[...assignmentNameCurrMap.keys()].map((assignmentName, i) => (
				<View key={i} style={asgmtDetailsStyle.assignmentCurriculumEntry}>
					<Text style={asgmtDetailsStyle.assignmentCurriculumName}>
						{assignmentName}
					</Text>
					<Text style={asgmtDetailsStyle.assignmentCurriculumCode}>
						{assignmentNameCurrMap.get(assignmentName)}
					</Text>
				</View>
			))}
		</View>
	);
};

function aggregateCurriculum(
	curriculumList: Curriculum[],
): Map<string, string> {
	// first sort by name; if equal, then sort by code
	const sortedCurriculumList = Array.from(curriculumList).sort(function (a, b) {
		return a.name.localeCompare(b.name) || a.code.localeCompare(b.code);
	});
	const assignmentNameCurrMap: Map<string, string> = new Map();

	sortedCurriculumList.forEach((curriculum) => {
		if (assignmentNameCurrMap.has(curriculum.name)) {
			const currCode: string = assignmentNameCurrMap.get(
				curriculum.name,
			) as string;
			assignmentNameCurrMap.set(
				curriculum.name,
				currCode + "; " + curriculum.code,
			);
		} else {
			assignmentNameCurrMap.set(curriculum.name, curriculum.code);
		}
	});
	return assignmentNameCurrMap;
}
